import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { NotificacaoTO } from "src/app/data/schema/Notifications/NotificacaoTO";
import { ApiNotificacaoService } from "src/app/data/service/notifications/api-notificacao.service";

@Injectable({
    providedIn: "root"
})
export class NotificationPopupService {
    private notificacoes: BehaviorSubject<NotificacaoTO[]>;
    private show: BehaviorSubject<boolean>;

    constructor(private notificacaoService: ApiNotificacaoService) {
        this.notificacoes = new BehaviorSubject<NotificacaoTO[]>([]);
        this.show = new BehaviorSubject<boolean>(false);
    }

    public getNotificationsAsync = (): void => {
        this.notificacaoService.getNotifications().subscribe((response) => {
            this.show.next(response.length > 0);
            this.notificacoes.next(response);
        });
    };

    public getNotificationsSync = (): NotificacaoTO[] => this.notificacoes.value;

    public getNotifications = (): Observable<NotificacaoTO[]> => this.notificacoes.asObservable();

    public getShow = (): Observable<boolean> => this.show.asObservable();

    public setShow = (show: boolean): void => this.show.next(show);
}
